import { BaseService } from './base.service'
import { ErrorWrapper, ResponseWrapper } from './util'

export class ReportingPeriodsService extends BaseService {
  static get entity () {
    return 'v1/reporting_periods'
  }

  static async get (params = {}) {
    let paramString = ''
    if (Object.keys(params).length > 0) {
        paramString = `?${this.querystring(params)}`
    }

    try {
      const response = await this.request({ auth: true }).get(`${this.entity}${paramString}`)
      return new ResponseWrapper(response, response.data)
    } catch (error) {
      console.log(error)
      const message = error.response.data ? error.response.data.error : error.response.statusText
      throw new ErrorWrapper(error, message)
    }
  }
}
